import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarController,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
import "../admin/admin.css"

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  BarController
);

export default function BarChart() {
  const data = {
    labels: ["Label 1", "Label 2", "Label 3", "Label 4", "Label 5"],
    datasets: [
      {
        label: "Data Series",
        backgroundColor: "rgba(75, 192, 192, 0.6)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
        data: [12, 19, 25, 15, 20]
      },
      {
        label: "Sample Data",
        data: [12, 19, 30, 15, 12],
        backgroundColor: ["green"]
      }
    ]
  };

  const options = {
    plugins: {
      legend: {
        display: true
      }
    },
    layout: {
      padding: {
        left: 5,
        right: 5,
        top: 10,
        bottom: 5
      },
      margin: {
        left: 5,
        right: 5,
        top: 15,
        bottom: 5
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        border: { dash: [6, 6], display: true },
        grid: {
          display: true // Display grid lines for the y-axis
        },
        ticks: {
          padding: 15
        }
      },
      x: {
        beginAtZero: true,
        border: { display: true },
        grid: {
          display: false // Display grid lines for the y-axis
        },
        ticks: {
          padding: 2
        }
      }
    },
    elements: {
      bar: {
        borderRadius: 5,
        borderWidth: 0.7
      }
    }
  };

  return (
    <div>
      <Bar data={data} options={options} />
    </div>
  );
}
